import { render, staticRenderFns } from "./HospitalIntroGzFsk.vue?vue&type=template&id=4b30b580&scoped=true"
import script from "./HospitalIntroGzFsk.vue?vue&type=script&lang=js"
export * from "./HospitalIntroGzFsk.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroGzFsk.vue?vue&type=style&index=0&id=4b30b580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30b580",
  null
  
)

export default component.exports